/** Display-only mask; never use for storage or send. */
export function maskPixKey(key: string): string {
  const value = key.trim();
  if (value.length < 6) return '***';
  return `${value.slice(0, 3)}***${value.slice(-3)}`;
}
